'use client'

export interface TOCItem {
    id: string
    label: string
}

interface TableOfContentsProps {
    items: TOCItem[]
}

/**
 * Table of contents navigation for C2C page sections.
 */
export function TableOfContents({ items }: TableOfContentsProps) {
    if (items.length === 0) {
        return null
    }

    return (
        <nav aria-label="Table of contents" className="sticky top-0 z-10 mt-[96px] bg-white">
            <ul className="mx-auto flex max-w-[1056px] flex-wrap gap-2 px-4 py-2 md:gap-x-3">
                {items.map(({ id, label }) => (
                    <li key={id} className="list-none md:flex-1">
                        <a
                            href={`#${id}`}
                            className="block rounded-[7px] bg-[#d9f5f9] px-2 py-1 text-center text-base font-medium text-[#5f6368] transition-colors hover:bg-[#8ce2ec] hover:text-[#008a99]"
                            onClick={(e) => {
                                e.preventDefault()
                                document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
                                window.history.pushState(null, '', `#${id}`)
                            }}
                        >
                            {label}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    )
}
